import React, { useState } from "react";

const domainOf = (website) => {
  if (!website) return "";
  try {
    const u = website.startsWith("http") ? website : `https://${website}`;
    return new URL(u).hostname.replace(/^www\./, "");
  } catch {
    return String(website).replace(/^https?:\/\//, "").replace(/^www\./, "").split("/")[0];
  }
};

// Tries an explicit uploaded logo, then Clearbit, then Google favicon, then a fallback node.
export default function CompanyLogo({ logo, website, name, fallback = null, imgClassName = "" }) {
  const domain = domainOf(website);
  const srcs = [logo, domain && `https://logo.clearbit.com/${domain}`].filter(Boolean);
  const [idx, setIdx] = useState(0);
  if (srcs.length === 0 || idx >= srcs.length) return fallback;
  return (
    <img src={srcs[idx]} alt={name || ""} className={imgClassName} loading="lazy" referrerPolicy="no-referrer"
      onError={() => setIdx((i) => i + 1)} data-testid="company-logo" />
  );
}
